// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"acd42c74","856":"ca0f5200"}[chunkId] + ".js";
};